import React from "react";
import { Leaf, CalendarCheck } from "lucide-react";

const scrollToForm = () => {
  const el = document.getElementById("contact-form");
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

// Haute saison : 1 mai – 30 août (mois 5 à 8). Sinon basse saison.
const getSeason = () => {
  const m = new Date().getMonth() + 1;
  const isHigh = m >= 5 && m <= 8;
  return {
    isHigh,
    label: isHigh ? "Haute saison" : "Basse saison",
    price: isHigh ? "145 €" : "120 €",
  };
};

const SeasonBanner = () => {
  const { label, price } = getSeason();
  return (
    <div className="bg-[#1C3A27] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex flex-col sm:flex-row items-center justify-center sm:justify-between gap-2 text-center sm:text-left">
        <p className="text-sm md:text-base flex items-center gap-2 flex-wrap justify-center">
          <Leaf size={16} className="text-[#E8C87E] flex-shrink-0" />
          <span className="text-white/80">Tarif en cours · {label} :</span>
          <span className="font-semibold">{price} / nuit</span>
          <span className="text-white/70">jusqu'à 4 voyageurs</span>
        </p>
        <button
          onClick={scrollToForm}
          className="inline-flex items-center gap-1.5 text-sm font-medium bg-white/10 hover:bg-white/20 border border-white/30 rounded-full px-4 py-1.5 transition-colors focus:outline-none focus:ring-2 focus:ring-white/60"
          aria-label="Vérifier mes dates - aller au formulaire de demande de séjour"
        >
          <CalendarCheck size={16} />
          Vérifier mes dates
        </button>
      </div>
    </div>
  );
};

export default SeasonBanner;
